import api from "./api";

export default async function checkModules() {
  try {
    const response = await api.post("/modulo/cliente/find");

    if (response.data) {
      localStorage.setItem("modulos", JSON.stringify(response.data));
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    localStorage.setItem(
      "modulosError",
      error?.response?.data?.error || error?.response?.data || error?.response,
    );
    console.error(error);
  }
}
